// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__W5kQY","col":"styles_col__pvMSF"};